import moment from "moment";

import { convertUtcToLocal } from "../../../Common/utils/dateUtils";

export const isScheduledSubmission = (submission) => (
  String(submission?.status || "") === "-2" && String(submission?.type || "").toLowerCase() === "scheduled"
);

export const getScheduledSubmissionDate = (submission) => (
  submission?.scheduled_date ?? submission?.schedule_date ?? ""
);

export const formatScheduledSubmissionDate = (submission) => {
  const dateIso = getScheduledSubmissionDate(submission);
  if (!dateIso) return "";
  const dateMoment = moment(convertUtcToLocal(dateIso));
  return dateMoment.isValid() ? dateMoment.format("DD MMM YYYY") : "";
};

export const getScheduledSubmissionTooltip = (submission) => {
  const formatted = formatScheduledSubmissionDate(submission);
  const formattedText = `Scheduled on ${formatted}`;
  return formattedText || "Scheduled date unavailable";
};

export const isDeletedSubmission = (submission) => {
  const { status } = submission ?? {};
  return status === -3 || status === "-3";
};

const STATUS_LABELS = {
  "-1": "Submitted",
  0: "Samples Received",
  1: "Testing in Progress",
  2: "Testing Complete",
};

const STATUS_CLASS_NAMES = {
  "-1": "submitted-submissions-status-text-submitted",
  0: "submitted-submissions-status-text-samples-received",
  1: "submitted-submissions-status-text-progress",
  2: "submitted-submissions-status-text-complete",
};

export const getSubmissionStatusLabel = (submission) => {
  if (isScheduledSubmission(submission)) return "Scheduled";
  if (isDeletedSubmission(submission)) return "Deleted";
  return STATUS_LABELS[submission?.status] || "";
};

export const getSubmissionStatusClassName = (submission) => {
  if (isScheduledSubmission(submission)) return "submitted-submissions-status-text-scheduled";
  if (isDeletedSubmission(submission)) return "submitted-submissions-status-text-deleted";
  return STATUS_CLASS_NAMES[submission?.status] || "";
};
